import api from "../../api";
import ENDPOINTS from "../../api/endpoints";
import UserAuthStore from "../../store/userStore";
import logger from "../../services/Logger";

export const updateRecaching = async (uid, value) => {
    const { user, orgId } = UserAuthStore.getState();

    try {
        await api({
            method: "POST",
            url: ENDPOINTS.RECACHE_SPARK,
            data: {
                chat_id: uid,
                org_id: orgId,
                owner_id: user?.uid,
                value,
            },
        });
    } catch (error) {
        logger.error('updateRecaching', 'Error updating recaching', { error: error.message, uid });
    }
};
